// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2-ON-","errors":"Errors_errors__2YxCV"};